import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deposit-renewal-grid',
  templateUrl: './deposit-renewal-grid.component.html',
  styleUrls: ['./deposit-renewal-grid.component.css']
})
export class DepositRenewalGridComponent implements OnInit {
  title="Deposit Renewal List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/deposit-renewal-grid/deposit-renewal-grid.component.ts